<script setup lang="ts">
import { computed } from 'vue';

import FileKindIcon from '@/components/files/FileKindIcon.vue';
import { metaRaw } from '@/utils/dataTable';
import { getFileKindFromMime } from '@/utils/files';

import type { DataTableCellProps } from './templateTypes';

const props = defineProps<DataTableCellProps>();

const rawMime = computed(() => metaRaw<string>(props.cell));

// Derive kind + icon
const fileKind = computed(() => getFileKindFromMime(rawMime.value));
</script>

<template>
  <ExpandableCell :data-key="dataKey" :field="column.field">
    <!-- Collapsed content -->
    <template #collapsed>
      <div class="text-center">
        <FileKindIcon
          v-tooltip="{
            value: rawMime ?? '',
            fitContent: true,
            showDelay: 300,
          }"
          :fileKind="fileKind"
        />
      </div>
    </template>

    <!-- Expanded content -->
    <template #expanded>
      <div>
        {{ cell.value }}
      </div>
    </template>
  </ExpandableCell>
</template>
